/**
 * 아침 브리핑 팝업을 **다른 화면에서 수동으로 열 때** 쓰는 이벤트 이름.
 *
 * 왜 상수만 따로 떼어 놓았나:
 * 이 이름은 팝업을 여는 쪽(오늘의 브리핑의 "아침 팝업 다시 보기")과
 * 듣는 쪽(MorningBriefingGate) 양쪽에 필요하다. 그런데 게이트 컴포넌트에서
 * 가져오면 **상수 하나 때문에 잠금 컨텍스트·인증·저장소가 통째로 딸려온다.**
 * 이름만 필요한 쪽은 이 파일만 보면 된다.
 */
export const OPEN_MORNING_BRIEFING_EVENT = 'rappo:open-morning-briefing';
